export const SET_TUTORIALS_LIST = "SET_TUTORIALS_LIST";
export const SET_TUTORIALS_BY_ID = "SET_TUTORIALS_BY_ID";
export const SET_TUTORIALS_BY_USERNAME = "SET_TUTORIALS_BY_USERNAME";
export const SET_REMOVE_TUTORIAL = "SET_REMOVE_TUTORIAL";
export const SET_ADD_TUTORIAL_LOADING = "SET_ADD_TUTORIAL_LOADING";
export const SET_TUTORIALS_LIST_LOADING = "SET_TUTORIALS_LIST_LOADING";
